import {useEffect} from "react";

const Busao0800 = () => {
  useEffect(() => {
    window.open(
      "https://busao0800.com",
      "_blank",
      "noreferrer noopener"
    );
  }, [])
  
  return <>Redirecionando...</>
}

export default Busao0800;
